import { drilldownData, ModuleFields } from "~/Utils/drilldownData";

export const fields: any = {
  cameraAccess: drilldownData["cameraAccess"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
  languagePopUp: drilldownData["languagePopUp"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
  purchaseLoginPopUp: drilldownData["purchaseLoginPopUp"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
  loginPopUp: drilldownData["loginPopUp"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
  logoutPopUp: drilldownData["logoutPopUp"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
  VMSPopUp: drilldownData["VMSPopUp"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
  hyperLinkPopUp: drilldownData["hyperLinkPopUp"].map(
    ({ fieldName, placeholder, name, formType, validation, className, hidden, options, loadOptions, usedFileType, note }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      hidden: hidden,
      options: options,
      loadOptions: loadOptions,
      usedFileType: usedFileType,
      note: note
    })
  ),
  welcomeBanner: drilldownData["welcomeBanner"].map(
    ({ fieldName, placeholder, name, formType, validation, className, hidden, usedFileType, note }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      hidden: hidden,
      usedFileType: usedFileType,
      note: note
    })
  ),
};
